export default __webpack_public_path__ + "static/media/teltonikafmb120.6db6d824.png";